<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          v-wechat-title="$route.meta.title"
        ></router-view>
      </keep-alive>
    </transition>
    <transition :name="transitionName">
      <router-view
        v-if="!$route.meta.keepAlive"
        v-wechat-title="$route.meta.title"
        :key="key"
      ></router-view>
    </transition>
    <TabBar safe-area-inset-bottom v-show="showTab" :isRead="isUnread" />
    <FloatNavs v-show="showNavs" />
    <floatButton></floatButton>
  </div>
</template>

<script>
import TabBar from '@/components/tabbar.vue'
import FloatNavs from '@/components/float-navs/index.vue'

import { isWxBrowser, goWxLogin } from './utils/login'
import { getInfo } from './api/commonApi.js'

export default {
  name: 'App',
  components: {
    TabBar,
    FloatNavs,
    floatButton: () => import('@/components/float-button/index.vue')
  },
  data () {
    return {
      showTab: false,
      showNavs: true,
      isWx: false,
      transitionName: '',
      isSlide: false,
      isUnread: false
    }
  },
  computed: {
    key () {
      return this.$route.fullPath + Math.random()
    }
  },
  watch: {
    $route (to, from) {
      // 切换动画
      let path = this.$route.path
      // console.log(this.$route.path);
      if (path === '/' || path === '/order' || path === '/my') {
        this.showTab = true
        this.showNavs = false
      } else {
        this.showTab = false
        this.showNavs = true
      }
      if (
        path.toLowerCase() === '/login' ||
        path.toLowerCase() === '/choose' ||
        path.toLowerCase() === '/qrcode'
      ) {
        this.showNavs = false
      }

      // 屏蔽原生滑动
      var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      var isPc =
        navigator.userAgent.indexOf('Windows') !== -1 ||
        navigator.userAgent.indexOf('Macintosh') !== -1
      if (isiOS) {
        document.body.addEventListener(
          'touchmove',
          () => {
            this.isSlide = true
          },
          false
        )
      }
      if (!this.isSlide && !isPc) {
        if (to.meta.index < from.meta.index) {
          // 设置动画名称
          this.transitionName = 'slide-left'
          this.isSlide = false
        } else {
          this.transitionName = 'slide-right'
          this.isSlide = false
        }
      } else {
        this.transitionName = ''
        this.isSlide = false
      }
    }
  },
  created () {},
  updated () {
    getInfo()
      .then(res => {
        this.isUnread = res.data.unReadMsg
      })
      .catch(() => {})
    window.scroll(0, 0)
  }
}
</script>

<style lang="less">
@import "./assets/css/colors.less";

* {
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none;
  // 禁止随着系统变大字体
  -webkit-text-size-adjust: 100%;
}
img {
  pointer-events: none;
}
.zip-picture {
  pointer-events: auto;
}
.container {
  background: #fff;
  box-sizing: border-box;
  padding-bottom: 80px;
  max-width: 750px;
  margin: 0 auto;
}
// 弹框
.van-overlay {
  background-color: rgba(0, 0, 0, 0.3);
}
.van-toast__text {
  font-size: 30px;
  padding: 20px 30px;
}
.van-toast--loading {
  width: 200px;
  height: 150px;
  .van-toast__text {
    font-size: 30px;
    padding: 25px 40px;
  }
}
.van-pull-refresh__head {
  font-size: 28px !important;
  span {
    font-size: 28px !important;
  }
}
// 轮播
.van-swipe__track {
  margin-bottom: 30px;
}
.van-swipe__indicator {
  width: 16px;
  height: 8px;
  border-radius: 4px;
  background-color: #c3f9fc;
}
.van-swipe__indicator--active {
  width: 34px;
  height: 8px;
  border-radius: 4px;
  background-color: @theme_color;
}
// 其他
.van-image-preview {
  .van-image-preview__close-icon {
    font-size: 64px;
  }
}
.van-image-preview__index {
  font-size: 30px;
}
.van-picker-column__item {
  font-size: 30px;
}
.van-datetime-picker {
  .van-picker__mask {
    border-radius: 0 0 24px 24px;
  }
}
.van-info--dot {
  width: 24px;
  height: 24px;
  background-color: #ff4b4b;
}
// 数字键盘
.van-key--blue {
  background-color: @theme_color;
  &.van-key--active {
    background-color: #1bced8;
  }
}
.van-number-keyboard {
  max-width: 750px;
  right: 0;
  margin: auto;
}
.van-number-keyboard__body {
  height: 400px;
  .van-key {
    height: 90px;
    &.van-key--blue.van-key--large {
      height: 270px;
      font-size: 26px;
    }
    &.van-key--delete {
      height: 110px;
    }
  }
}
// 弹框
.van-dialog {
  width: 552px;
  border-radius: 16px;
  box-shadow: 0px 0px 28px rgba(0, 0, 0, 0.16);
  .van-dialog__header {
    font-size: 32px;
    font-weight: bold;
    line-height: 48px;
    margin: 40px;
  }
  .van-dialog__message {
    font-size: 36px;
    line-height: 48px;
    margin: 40px;
    &.van-dialog__message--has-title {
      font-size: 28px;
    }
  }
  .van-button {
    font-size: 32px;
    height: 88px;
  }
  .van-dialog__cancel {
    color: #999;
  }
  .van-dialog__confirm {
    background: @theme_color;
    color: #fff;
  }
}
// 上传
.van-uploader__input-wrapper {
  order: -1;
  margin: 0 10px 12px 0;
  max-width: 160px;
  max-height: 160px;
}
.van-uploader__preview {
  margin: 0 10px 12px 0;
  .van-uploader__preview-image {
    border-radius: 12px;
  }
  .van-uploader__preview-delete {
    width: 44px;
    height: 34px;
    background: url("./assets/icon_del.png") no-repeat;
    background-size: cover;
    border-radius: 0;
    top: auto;
    right: 0;
    bottom: 0;
    &::before {
      display: none;
    }
  }
}
.van-uploader__mask-message {
  margin-top: 20px;
}
.van-icon-close.van-uploader__mask-icon::before {
  content: "\F0DF";
  color: yellow;
  transform: scale(1.5);
}
// 骨架
.van-skeleton {
  margin-bottom: 50px;
}
.van-skeleton__title,
.van-skeleton__row {
  height: 32px;
}

// 局部导航栏
.van-tabs {
  overflow: hidden;
}
.van-tabs--line .van-tabs__wrap {
  height: 80px;
  margin: 44px 0 44px 28px;
}
.van-tab {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 68px;
  margin: 0 12px;
  padding: 14px 32px;
  font-size: 28px;
  font-weight: bold;
  color: #999;
  background: #fff;
  border: 1px solid #d6d8d8;
  border-radius: 12px;
  &--active {
    color: #fff;
    background: linear-gradient(
      151deg,
      rgba(39, 172, 139, 1) 0%,
      rgba(99, 238, 203, 1) 100%
    );
    border: 1px solid transparent;
  }
}
.van-hairline--top-bottom::after {
  display: none;
}
.van-tabs__line {
  display: none;
}
@keyframes first {
  0% {
    margin-left: 0%;
  }
  25% {
    margin-left: -25%;
  }
  50% {
    margin-left: -50%;
  }
  75% {
    margin-left: -25%;
  }
  100% {
    margin-left: 13px;
  }
}
.aniTab .van-tabs__wrap--scrollable {
  animation: first 2s;
  animation-timing-function: linear;
  animation-iteration-count: 1;
}
// 页面过渡动画
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.5s;
  position: absolute;
  width: 100%;
  left: 0;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

// 单选框
input[type="radio"] {
  width: 32px;
  height: 32px;
  -webkit-appearance: none;
  background-color: transparent;
  border: 0;
  outline: 0 !important;
  position: relative;
  background-image: url("./assets/icon_radio.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
input[type="radio"]:checked {
  background-image: url("./assets/icon_radio_check.png");
}
// 复选框
input[type="checkbox"] {
  width: 36px;
  height: 36px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  line-height: 36px;
  position: relative;
  -webkit-appearance: none;
  background-color: transparent;
  border: 0;
  outline: 0 !important;
  background-image: url("./assets/icon_checkbox.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
input[type="checkbox"]:checked {
  background-image: url("./assets/icon_checkbox_check.png");
}
</style>



// WEBPACK FOOTER //
// src/App.vue